let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lWQgD")).then(() => parcelRequire('5isYx'));